export default __webpack_public_path__ + "static/media/4 Accounts Department.7eae3b25.jpg";